import classNames from 'clsx';
import { camelCase } from 'lodash';
import React from 'react';

import styles from './StarsInfo.scss';

export type Type = 'info' | 'confirmation' | 'error' | 'warning';

export interface Props {
  /**
  Provides additional styling possibility.
  */
  className?: string;
  /**
  Use the error type to indicate error.
  */
  type?: Type;
}

/**
> **Supercharge documentation with Markdown/MDX code blocks**

###### This block is written in JSDoc format in packages/swf-components/StarsInfo/StarsInfo.tsx

```tsx
import StarsInfo from '@swf/components/StarsInfo/StarsInfo';

<StarsInfo>Default message</StarsInfo>
<StarsInfo type="confirmation">Confirmation message</StarsInfo>
<StarsInfo type="error">Error message</StarsInfo>
```
*/
const StarsInfo: React.FC<Props> = ({ type = 'info', className, children }) => (
  <div
    className={classNames(
      styles.info,
      styles[camelCase(`type-${type}`) as keyof typeof styles],
      className
    )}
  >
    {children}
  </div>
);

export default StarsInfo;
